module.exports = __webpack_public_path__ + "img/IMG_8155_L_BlackMatted.b391d852.jpg";